export const options = [
  {
    id: 1,
    skill: "Beginner",
    description: "Almost 0 knowledge",
  },
  {
    id: 2,
    skill: "Beginner",
    description: "Basic understanding",
  },
  {
    id: 3,
    skill: "Intermediate",
    description: "Have done some work on it",
  },
  {
    id: 4,
    skill: "Expert",
    description: "Work regularly with it",
  },
];

export const courses = [
  {
    id: 1,
    name: "Programming",
    course_slug: "programming-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Coding_1.svg?updatedAt=1688364023282",
  },
  {
    id: 2,
    name: "Digital Marketing",
    course_slug: "digital-marketing-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Digital_Marketing_25.svg?updatedAt=1688364137460",
  },
  {
    id: 3,
    name: "Data Science & Analytics",
    course_slug: "data-science-analytics-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Data_Science_1.svg?updatedAt=1688364191116",
  },
  {
    id: 4,
    name: "Design, Art & Tools",
    course_slug: "design-art-tools-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Pencil_with_Ruler.svg?updatedAt=1688364239209",
  },
  {
    id: 5,
    name: "Finance & Investments",
    course_slug: "finance-investments-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/finance_1.svg?updatedAt=1688364280208",
  },
  {
    id: 6,
    name: "UI/UX",
    course_slug: "uiux-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/UI_UX_Design_1.svg?updatedAt=1688364322372",
  },
  {
    id: 7,
    name: "Business & Management",
    course_slug: "business-management-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Business_1.svg?updatedAt=1688364372090",
  },
  {
    id: 8,
    name: "Language",
    course_slug: "language-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Language_Translate_1.svg?updatedAt=1688364410223",
  },
  {
    id: 9,
    name: "Cloud Computing",
    course_slug: "cloud-computing-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Cloud_Computing_1.svg?updatedAt=1688364460111",
  },
  {
    id: 10,
    name: "Operating System and Databases",
    course_slug: "operating-system-and-databases-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Operating_System_1.svg?updatedAt=1688364497142",
  },
  {
    id: 11,
    name: "Hardware and Network Security",
    course_slug: "hardware-and-network-security-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Hardware_1.svg?updatedAt=1688364553384",
  },
  {
    id: 12,
    name: "Film Making",
    course_slug: "film-making-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/film_making_1.svg?updatedAt=1688364620738",
  },
  {
    id: 13,
    name: "Development Tools and No Code",
    course_slug: "development-tools-and-no-code-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Software_Development_26.svg?updatedAt=1688364645466",
  },
  {
    id: 14,
    name: "Web 3",
    course_slug: "web-3-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Nft_1.svg?updatedAt=1688364684918",
  },
  {
    id: 15,
    name: "Music",
    course_slug: "music-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Music_Sign_1.svg?updatedAt=1688364728768",
  },
  {
    id: 16,
    name: "Music",
    course_slug: "music-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Music_Sign_1.svg?updatedAt=1688364728768",
  },
  {
    id: 17,
    name: "Job Application Guides",
    course_slug: "job-application-guides",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Music_Sign_1.svg?updatedAt=1688364728768",
  },
  {
    id: 18,
    name: "Others",
    course_slug: "others-courses",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Music_Sign_1.svg?updatedAt=1688364728768",
  },
];

export const questionLoader = [
  {
    id: 1,
    description: "Analysing the skill map",
  },
  {
    id: 2,
    description: "Generating questions for you",
  },
  {
    id: 3,
    description: "Loading questions and optimising quiz settings",
  },
  {
    id: 4,
    description: "Loading questions and optimising quiz settings",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Vivek Jarngal",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Ellipse_907.png?updatedAt=1685776843845",
    designation: "Freelance Designer",
    description: `“This is exactly what I was looking for”`,
  },
  {
    id: 2,
    name: "Bala Nath Rai",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Ellipse_907__1_.png?updatedAt=1685776939014",
    designation: "Account Executive",
    description: `“Wow, I really didn’t know there was so much I needed to learn!”`,
  },
  {
    id: 3,
    name: "Shruti Das",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Shruti.png?updatedAt=1685777697916",
    designation: "Web Developer",
    description: `“Finally, a course that understands me & my goals!”`,
  },
  {
    id: 4,
    name: "Somesh Mishra",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Ellipse_907__3_.png?updatedAt=1685777109765",
    designation: "Project Manager",
    description: `“I’ve been looking since months when the perfect course was just minutes away..”`,
  },
];

export const questionsAnalysis = [
  {
    id: 1,
    name: "What is the difference between UI and UX design",
    topicsIknow:
      "Signups and conversion numbers can be used to measure success of product marketing efforts.",
    topicsIdontknow: "Signups and conversion numbers can be used.",
  },
  {
    id: 2,
    name: "What is the difference between UI and UX design",
    topicsIknow: "Signups and conversion numbers can be used.",
    topicsIdontknow: "",
  },
  {
    id: 3,
    name: "What is the difference between UI and UX design",
    topicsIknow: "",
    topicsIdontknow: "Signups and conversion numbers can be used.",
  },
];

export const expertsData = [
  {
    expert_name: "Ravi Garikipati",
    designation: "Ex-CTO",
    imgLink:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_52.png?updatedAt=1685423721302",
    companyImage:
      "https://img.learntube.ai/public-assets/About-us/Flipkart_-_png_0.png?updatedAt=1685423777121",
    companyName: "Flipkart",
  },
  {
    expert_name: "Kaushik Subramanian",
    designation: "Business Product Lead",
    imgLink:
      "https://img.learntube.ai/public-assets/About-us/Rectangle_520323456.png?updatedAt=1685423959561",
    companyImage:
      "https://img.learntube.ai/public-assets/About-us/Facebook_-_png_0.png?updatedAt=1685424009735",
    companyName: "Facebook",
  },
];

export const LessonFaqs = [
  {
    id: 0,
    question: "How is this course personalised for me?",
    answer:
      "Our domain experts (with 30+ years of combined experience) along with our AI engine analyse your skills, goals & answers to identify what you need to learn. We then build a detailed syllabus accordingly for you. And the personalisation doesn’t end here. Once you start learning, your course will be further personalised to you as per your needs.",
  },
  {
    id: 1,
    question: "What all courses do you offer?",
    answer:
      "Our personalisation technology works across domains, from career skills like Java to even hobbies like baking. Most users use us to learn work related skills in the domain of Programming, Marketing, Data Science, Design, Business & lots of different tools.",
  },
  {
    id: 2,
    question: "Does the course really help in jobs?",
    answer:
      "Yess! If you learn properly, do your assessments & projects and then showcase your skills in your CV & portfolio to employers it will make a huge difference in your job applications & even your own confidence. Our learners work at top companies from Amazon to TCS and many have gone on to become freelancers & entrepreneurs.",
  },
  {
    id: 3,
    question: "Does LearnTube make the content too?",
    answer:
      "We make personalised, certified courses. We do not make the videos in the course. Those are sourced from across the internet to make sure we get the very best content for you. Most videos are from top YouTube creators. We do the hard work of figuring out what you need to learn, finding the very best videos for it, arranging it in the best order, assessing your skills, solving your doubts, giving you projects to do & then certifying you.",
  },
  {
    id: 4,
    question: "How do I get certified?",
    answer:
      "Once you complete the course & assessments you will get certified immediately. Our certificate is recognised by hundreds of companies.",
  },
  {
    id: 5,
    question: "Is there any refund policy?",
    answer:
      "There sure is. While completing your course, if you find a cheaper, more personalised course than ours you will get your money back! Just reach out to us within 7 days of purchase with the details on hello@careerninja.in",
  },
];

export const SuccessStories = [
  {
    id: 1,
    name: "Shwetha S.",
    description: `After spending over two years in a role that didn’t excite me, I knew I needed a change, but with no tech background, the transition felt overwhelming. I applied to over 100 jobs and faced rejection after rejection, which was incredibly frustrating. That’s when I discovered LearnTube, and everything started to change.\n

What made the difference for me was the customized learning plan that was perfectly tailored to my needs. I gained hands-on experience through real-world projects that helped me build practical skills. The expert mentorship I received helped me navigate the challenges of being a fresher, and the polished resume I created showcased my new skills in a way that impressed recruiters. On top of that, the interview preparation boosted my confidence and gave me the tools to succeed.\n

Within just a month, I secured my dream role at Baker Hughes, with a 150% salary hike! It wasn’t easy, but I stayed committed, worked hard, and relentlessly upskilled. I’m truly grateful for the role LearnTube played in my journey.`,
    videoUrl: "https://youtu.be/0g9Ddz2ips8",
    from: "Customer Software Associate",
    to: "Data Engineer",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Shwetha%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(9).png?updatedAt=1706100044811",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Shwetha%20Company.png",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(2).png",
  },
  {
    id: 2,
    name: "Ankit S.",
    description: `After 5+ years in pharma R&D, I felt stuck. Everyone around me was in the same role for years, and I knew I needed a change. I spent 18 months trying to learn data on my own — YouTube, PDFs, tutorials. But I wasn’t making progress.\n

That’s when I joined LearnTube.\n

With a personalized learning path tailored to my background, I completed 4 real-world projects in just 30 days, including a healthcare ML model that showcased my expertise. The results were immediate. A recruiter from a top investment firm reached out. No tests, no endless interviews — just one conversation about my work, followed by a 35% salary hike.\n

LearnTube didn’t just teach me. They helped me build work that got me noticed. If you’re stuck, take the leap. The right support makes all the difference.
`,
    videoUrl: "https://youtube.com/shorts/OqqTNCIrKR0",
    from: "Computer Engineer",
    to: "Full Stack Developer",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Ankit%20Image.png",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Ankit%20Company.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205147.png?updatedAt=1706100149035",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(3).png",
  },
  {
    id: 3,
    name: "Selvam Pillai",
    description: `With over 8 years of experience, I realized that despite my practical background, I lacked a formal certification to stand out in the competitive job market. I discovered LearnTube by Career Ninja on Instagram and completed their “Recruitment” Certificate. The certification instantly boosted my credibility and opened up new opportunities.\n

After updating my LinkedIn and Naukri profiles with the certification, the response was overwhelming. I went from receiving 4-5 recruiter calls per week to 15-16, including from top MNCs like Intel, Solar Energy companies, and India’s First Insurance. It was clear that the certification made a significant impact on my job prospects.\n

LearnTube not only provided me with an industry-recognized certification but also offered structured learning and personalized support. Their guidance, along with help in crafting professional testimonials and branding, played a key role in enhancing my career.`,
    videoUrl: "https://www.youtube.com/shorts/API2-cAB9hc",
    from: "HR Executive",
    to: "Sr. Recruitment Consultant",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Selvam%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205148.png?updatedAt=1706100206471",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Selvam%20Company.png",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(4).png",
  },
  {
    id: 4,
    name: "Saitrik C",
    description: `I had the skills, a gold medal in MSc Cyber Security and 2.5 years of experience in vulnerability management. But despite all this, I felt like growth was out of reach, and I was stuck in my role.\n

That’s when I decided to enroll in LearnTube. I wanted to truly assess where I stood and see if I could level up my skills. The structured learning and certification program helped me sharpen my expertise and gain new insights that set me apart in my field.\n

I cracked the certification, and it didn’t take long for my manager to notice the difference. During my performance appraisal, he acknowledged the value I was now bringing to the team.\n

The result? A 75% salary hike, from ₹9L to ₹16L, and I didn’t even have to change jobs. It wasn’t about moving companies, it was about how my current company saw me in a completely new light.`,
    videoUrl: "https://www.youtube.com/shorts/aGfFzUIvAko",
    from: "Associate",
    to: "Consultant Vulnerability Researcher",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Saitrik%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205149.png?updatedAt=1706100257026",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Saitrik%20Company.png",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(5).png",
  },
  {
    id: 5,
    name: "Bhavmeet Kaur",
    description: `As a Senior Executive in Digital Marketing at Ablysoft, I recognized the need to elevate my skills for career advancement. Discovering LearnTube, a renowned learning platform, I focused on strengthening my SEO expertise to boost my prospects in placement interviews. LearnTube's video-based courses offered flexibility, allowing me to revise and enhance my knowledge at my convenience. The interactive learning approach made the process enjoyable.\n

Delving into LearnTube's SEO courses increased my confidence. Emphasizing practice and real-world applications, the platform enabled me to grasp concepts with clarity. Well-prepared, I faced interviews with confidence, securing a Management Trainee position at Reliance Retail. Joining on July 3, 2023, with a 24 LPA salary, this journey from Ablysoft to LearnTube and finally to Reliance Retail signifies growth, self-improvement, and determination. Grateful to LearnTube for the transformative learning experience that opened doors to this remarkable opportunity.`,
    videoUrl: "https://www.youtube.com/shorts/kf0sz6k4S3U",
    from: "Digital Marketing Executive",
    to: "Business Ops. Manager",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Bhavmeet%20image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205150.png?updatedAt=1706100314081",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Bhavmeet%20Company.png",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(7).png",
  },
  {
    id: 6,
    name: "Dr. Pritish",
    description: `During my final year of MBBS, I juggled various roles, including founding my startup, Fidorhealth, while holding prestigious positions like National IT Director at AMSA and Vice President at GAIM. To expand my digital reach and impact, I explored SEO and digital marketing, and that's when I found LearnTube. It offered free, high-quality content and valuable certificates, becoming my go-to platform.\n

 LearnTube's budget-friendly yet comprehensive content covered everything I needed to know, from digital marketing to mastering interview techniques. Despite facing personal challenges with cancer, I persevered and was honored by the Indian Book of Records. Thanks to LearnTube, I achieved financial success and now earn 10 LPA, realizing that continuous learning and staying updated are vital for sustained success.`,
    videoUrl: "https://youtu.be/KKpDsm0PPSc",
    from: "Student",
    to: "Co-Founder",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Pritish%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205151.png?updatedAt=1706100362879",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Pritish%20Company.png",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(8).png",
  },
  {
    id: 7,
    name: "Dasharath Shetty",
    description: `As an Oracle developer at TCS with 8 years of experience in the IT industry, my career was at a crossroads, and I longed for a change. That's when I stumbled upon LearnTube, a game-changing platform. I dug into Python through LearnTube's comprehensive courses, mastering it from the basics to advanced concepts. The structured approach and practical examples fueled my learning journey.\n

Coding slowly became my second nature, and I felt more confident than ever before. With my newfound knowledge, I landed a job with a lucrative salary of 15 LPA, thanks to LearnTube. Now, I'm reentering the IT industry with updated skills and expertise, all thanks to LearnTube's guidance and practical knowledge.
`,
    videoUrl: "https://youtube.com/shorts/Fkk68_W4b90",
    from: "Salesforce Analyst",
    to: "Sr. Product Analyst",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Dasharath%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205152.png?updatedAt=1706100433715",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Dashrath%20Company.png",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(9).png",
  },
  {
    id: 9,
    name: "Papia Chakraborty",
    description: `In June 2022, I embarked on my entrepreneurial journey, founding CUREASURE, an Assam-based startup, armed with 7 years of digital marketing experience and Photoshop proficiency. As the sole person handling everything, I knew continuous growth was vital.\n

Discovering LearnTube was a revelation - it aligned perfectly with my goals of managing the startup while upgrading my skills. Their practical courses empowered me to build my website, resulting in a 60% increase in traffic retention.\n

With each earned certificate, my online presence soared - followers increased by 80 per month, and impressions reached over 200. Today, my startup flourishes, generating a monthly income of 5,000 to 10,000 rupees,proving that investing in knowledge and upskilling is the true path to success.`,
    videoUrl: "https://youtu.be/IO8RJWDgvio",
    from: "Sr. Executive Assistant",
    to: "Operations Manager",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Papia%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205153.png?updatedAt=1706100491936",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Papia%20Company.png",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(10).png",
  },
  {
    id: 10,
    name: "Dinesh Gupta",
    description: `From facing financial hardships to becoming a self-made professional, my journey has been nothing short of inspiring. With a generous scholarship from Make a Difference (MAD), I pursued my college education. I switched to a BSc in Computer Science due to unaffordable engineering college fees.\n

In 2022, I stumbled upon LearnTube, which offered free education and job prospects. I seized the opportunity and focused on learning ML, C++, and advanced programming through webinars and resume-building sessions. Despite setbacks, I secured shortlisted opportunities from renowned companies like Goldman Sachs, Paypal, Mirae Asset Capital, Kalyan Jewellers, and Omniversity.\n

Eventually, I joined Mirae Asset Capital as a software developer in the capital market division. Earning 4.5 lakhs per annum with a 50,000 rupee bonus, I continue learning from LearnTube, preparing for my future. I've learned that challenges don't dictate our paths. With determination, education, and the willingness to learn, we can turn dreams into reality.
`,
    videoUrl: "https://youtu.be/owPU14dLvqs",
    from: "Developer",
    to: "Software Developer",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Dinesh%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205154.png?updatedAt=1706100529885",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Dinesh%20Company.png",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(1).png",
  },

  {
    id: 11,
    name: "Meenakshi J.",
    description: `Juggling life as a mom, wife, and professional, I always dreamed of building a meaningful career in IT. But balancing responsibilities, facing rejections, and dealing with self-doubt wasn’t easy.\n

That’s when I found LearnTube. With their support, I sharpened my skills, revamped my CV, and built the confidence to aim higher. In just 27 days, I achieved my goal as a Data Scientist with a 30% salary hike!`,
    videoUrl: "https://youtube.com/shorts/XzNJV9qZXa0",
    from: "Associate",
    to: "Data Scientist",
    thumbNail:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Meenakshi%20Image.png",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(9).png?updatedAt=1706100044811",
    companyLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Meenakshi%20Company.png",
    companyModalLogo:
      "https://img.learntube.ai/public-assets/Academy%20bundle/Modal%20icon%20(6).png",
  },
];

export const courseFeatures = [
  "Hands-off Experience of Figma",
  "Create Wireframes From Concepts",
  "Developer Functioning Micro Animations",
  "Understand Basic Working of HTML & CSS",
];

export const companyList1 = [
  "https://img.learntube.ai/public-assets/About-us/Stripe_-_png_0.png?updatedAt=1689841721147",
  "https://img.learntube.ai/public-assets/About-us/Netflix_-_png_0.png?updatedAt=1689841784275",
  "https://img.learntube.ai/public-assets/About-us/Twitter__-_png_0.png?updatedAt=1689841630758",
  "https://img.learntube.ai/public-assets/About-us/Spotify_-_png_0.png?updatedAt=1689841851007",
  "https://img.learntube.ai/public-assets/About-us/Expedia_-_png_0.png?updatedAt=1689842162702",
  "https://img.learntube.ai/public-assets/About-us/Apple_-_png_0.png?updatedAt=1689842084926",
  "https://img.learntube.ai/public-assets/About-us/Adobe_-_png_0.png?updatedAt=1689841946750",
  "https://img.learntube.ai/public-assets/About-us/Tata_Consultancy_Services_-_png_0.png?updatedAt=1689842026923",
  "https://img.learntube.ai/public-assets/About-us/Airbnb_-_png_0.png?updatedAt=1689842238525",
  "https://img.learntube.ai/public-assets/About-us/Slack_-_png_0.png?updatedAt=1689842318844",
  "https://img.learntube.ai/public-assets/About-us/Intel_-_png_0.png?updatedAt=1689842367676",
  "https://img.learntube.ai/public-assets/About-us/Figma_-_png_0.png?updatedAt=1689842408135",
  //'https://img.learntube.ai/public-assets/LinkdinUsers/Canva%20-%20png%200.png?updatedAt=1702706499682'
];

export const companyList2 = [
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Expedia_-_png_0.png?updatedAt=1685600083978",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Adobe_-_png_0.png?updatedAt=1685600084282",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Apple_-_png_0.png?updatedAt=1685600084366",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Tata_Consultancy_Services_-_png_0.png?updatedAt=1685600084479",
];

export const companyList3 = [
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Airbnb_-_png_0.png?updatedAt=1685600253243",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Slack_-_png_0__1_.png?updatedAt=1685600253185",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Intel_-_png_0.png?updatedAt=1685600253088",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Figma_-_png_0.png?updatedAt=1685600252737",
];

export const companyLogo1 = [
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Facebook_-_png_0__1_.png?updatedAt=1685624352896",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Amazon_-_jpeg_0.png?updatedAt=1685624249275",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Apple_-_png_0__1_.png?updatedAt=1685624249085",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Netflix_-_png_0__1_.png?updatedAt=1685624248825",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Google_-_png_0__1_.png?updatedAt=1685624248441",
];

export const companyLogo2 = [
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/image_340.png?updatedAt=1685624248922",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/image_343.png?updatedAt=1685624509156",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/image_344.png?updatedAt=1685624248932",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/image_345.png?updatedAt=1685624248680",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Paytm_-_jpeg_0.png?updatedAt=1685624248692",
];

export const successStories = [
  {
    id: 1,
    name: "Kishore V",
    description:
      "Having completed my MBA in Business Administration, my inclination towards the financial sector led me to a position in a cooperative bank. Seeking a transition to the tech field, a mutual friend recommended LearnTube as the ideal platform for upskilling and acquiring tech skills.\nThe courses, meticulously structured and easily comprehensible, facilitated my learning journey. Within a span of 3 weeks, I successfully completed around 7-8 micro-skills in UI/UX Design. The depth of the course videos and the inclusion of quizzes significantly enhanced my understanding and retention of the material.\nLearnTube's experienced mentors, who are domain experts, conducted weekly sessions, providing me with the opportunity to address any doubts or queries I encountered. I wholeheartedly endorse LearnTube to anyone seeking to upskill and navigate a career transition!",
    videoUrl: "https://youtu.be/vVUpuvHWaz8",
    from: "From Finance",
    to: "Tech in 3 Weeks",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146.png?updatedAt=1706083679906",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(9).png?updatedAt=1706100044811",
  },
  {
    id: 2,
    name: "Fahmida",
    description:
      "My substantial academic development, spanning from the initial year to the ultimate year, owes a considerable portion of its success to the remarkable support I received in upskilling through a platform I stumbled upon on Instagram, known as LearnTube. Delving into their courses, I made the strategic decision to specialize in digital marketing.\nThe LearnTube experience went beyond merely imparting new skills and securing verified certifications; it became a transformative force in bolstering my resume and offering invaluable interview preparation assistance. The comprehensive nature of the courses allowed me to navigate the intricacies of digital marketing with confidence and competence.",
    videoUrl: "https://youtu.be/JfGX8-Z55EE",
    from: "Fresher",
    to: "A Digital Marketing Specialist",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(1).png?updatedAt=1706083773178",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205147.png?updatedAt=1706100149035",
  },
  {
    id: 3,
    name: "SHUBHAM GAIKWAD",
    description:
      "As a Computer Engineering student, my aspiration was to explore the realm of Web Development. While I possessed some preliminary knowledge, delving into the courses offered by LearnTube unveiled the vastness of the field. Through LearnTube, I not only obtained certifications in HTML, Java, and CSS but also applied these acquired skills in a practical project. The experienced mentors at LearnTube played a pivotal role in providing guidance, imparting real-world knowledge that transcended the theoretical realm.\nThe exceptional team at LearnTube was consistently supportive, readily available whenever I required assistance. This collaborative environment enhanced my learning experience, fostering a sense of confidence and competence in the intricate domain of Web Development. LearnTube not only equipped me with certifications but also facilitated the practical application of skills, bridging the gap between theoretical understanding and real-world implementation.",
    videoUrl: "https://youtu.be/zQbxAQESw8Y",
    from: "Computer Engineer",
    to: "An expert Web Developer",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(2).png?updatedAt=1706083884308",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205148.png?updatedAt=1706100206471",
  },
  {
    id: 4,
    name: "Aftab ahmed",
    description:
      "Despite having a masters in aerospace engineering I was always intrigued by the world of artificial intelligence as well as robotics. That's where LearnTube came in.\n I completed various courses on LearnTube related to AI such as data structures & algorithms, python, machine learning and deep learning. I love the fact that they have content from a whole range of tutors, and you can learn from the ones who best suit you.\nSomething I found very useful was the mentorship program, which ensured that I got valuable advice that sped up my preparation. LearnTube also helped me build valuable projects using cutting-edge technology and make me confident to face interviews, and I'm hopeful that I will get into my dream company.",
    videoUrl: "https://youtu.be/nPFIEpK8NKE",
    from: "Pivot from Aersopace engineering",
    to: "AI",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(3).png?updatedAt=1706083986393",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205149.png?updatedAt=1706100257026",
  },
  {
    id: 5,
    name: "Dinesh",
    description:
      "After my graduation, I was on the lookout for internships and full-time jobs when a friend told me about an app called LearnTube. I signed up and started learning various courses such as Computer Fundamentals and some programming languages. The courses were well structured and the videos explained the concepts in depth, which benefited me a lot in enhancing my skills.\nArmed with stronger and better skillsets, I landed an internship at Candere by Kalyan Jewellers with a great stipend. I kept gaining more skills on LearnTube along with my internship. Once my internship was over, I decided to turn my focus towards getting a full time job.\nI started learning some core skills such as Machine Learning and enhancing my CV and profile, all of which led me to crack an excellent job opportunity at Mirae Asset Capital Markets as a Software Developer, with a significant salary bump and great perks!",
    videoUrl: "https://youtube.com/shorts/WU2okGs-fJE?feature=share",
    from: "Graduate",
    to: "Landing an internship at Kalyan Jewellers ",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(4).png?updatedAt=1706084058078",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205150.png?updatedAt=1706100314081",
  },
  {
    id: 6,
    name: "Darshan Deshmukh",
    description:
      "Enrolling in LearnTube initiated my exploration of various Python courses, with a focus on Modules and Packages. Completing these courses significantly enhanced my understanding of Python and its crucial role in data analytics, vital for my ongoing pursuits in this field.\nAddressing challenges or unclear concepts during the learning process became effortless by consulting the experienced mentors on LearnTube. Their guidance played a key role in fortifying my understanding and strengthening foundational concepts.\nAn exceptional feature of these courses is their cost-free nature, ensuring access to valuable learning resources without financial burden. This not only fosters a conducive learning environment but also democratizes education, providing high-quality Python courses to learners without monetary constraints. LearnTube has truly become an invaluable asset in my journey to expertise in Python and data analytics.",
    videoUrl: "https://youtube.com/shorts/iJxXNE5DsVM?feature=share",
    from: "Novice",
    to: "An Expert Data Analyst",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(5).png?updatedAt=1706084101420",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205151.png?updatedAt=1706100362879",
  },
  {
    id: 7,
    name: "Ribhu",
    description:
      "Being a freelancer, I knew that despite having a Masters degree in Mass Communication, I needed to keep updating my skills to have a competitive edge in my career. I started learning Search Engine Marketing on LearnTube to understand the field of SEM in depth and Marketing as a whole and enhance my knowledge.\nThe best part about LearnTube is that they support you through every step of your upskilling journey and help you analyze your progress from start to end and provide insightful tips to boost your learning curve.\nAfter finishing the SEM courses on LearnTube, I have a much deeper understanding about the subject. I am confident in demonstrating my SEM skills to my clients and in the process even gained new clients!",
    videoUrl: "https://youtu.be/pKkerknQF5k",
    from: "Passive freelancing",
    to: "Landing countless clients",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(6).png?updatedAt=1706084153970",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205152.png?updatedAt=1706100433715",
  },
  // {
  //     id: 8,
  //     name: 'Rohan Mudhiraj',
  //     description: "As an engineering student, I knew the importance programming had on my career growth, but I couldn't find the right place to start learning. While doing some intensive research I came across this interesting place called LearnTube by CareerNinja.\nI was blown away by the vast number of quality courses they had on various industry-relevant skills in domains like programming, digital marketing, cloud computing and more. I started learning Python and MySQL and it was a very good educational experience.\nAfter completing the courses, I got verified certificates which I flaunted on my resume, and it made my resume much stronger. I also loved the fact that they kept giving micro-quizzes during the course which kept me on my toes and boosted my knowledge.",
  //     videoUrl: 'https://youtube.com/watch?v=p09JbA3FDgQ&feature=share',
  //     from: 'Ordinary engineering student',
  //     to: 'A higly skilled programmer',
  //     thumbNail: 'https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(7).png?updatedAt=1706084200717'
  // },
  {
    id: 9,
    name: "Sree Varsha",
    description:
      "Being a computer science and engineering I was always intrigued by the world of Full stack development . That's where LearnTube came in.\nI completed various courses on LearnTube related to Full Stack Development such as data structures & algorithms, Front end development (HTML, CSS, JS and REACT JS) , Backend (MERN) and much more. I love the fact that they have content from a whole range of tutors, and you can learn from the ones who best suit you.\nSomething I found very useful was the mentorship program, which ensured that I got valuable advice that sped up my preparation. LearnTube also helped me build valuable projects using cutting-edge technology and make me confident to face interviews, and I'm hopeful that I will get into my dream company.",
    videoUrl: "https://youtu.be/3vFEJQarDjg",
    from: "Computer Science Engineer",
    to: "A Full Stack Developer",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(7).png?updatedAt=1706084200717",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205153.png?updatedAt=1706100491936",
  },
  {
    id: 10,
    name: "Rupa Shree",
    description:
      "Earning five LearnTube certifications in a month marked the start of my academic journey. The WhatsApp bot amazed me, enabling seamless learning on the go, even amid travel or work. LearnTube's organized courses, with regular quizzes, fortified my understanding and ensured concept retention, boosting confidence in my PGDM studies.\nLearnTube's versatile approach, integrating the WhatsApp bot, made education flexible. The structured curriculum, with interactive quizzes, vitalized my knowledge for PGDM challenges. LearnTube's commitment to enhancing learning was evident, offering a valuable resource that significantly enriched my academic pursuits.",
    videoUrl: "https://youtu.be/KvygfsHoUUE",
    from: "Went from achieveing 5 Certificates a month",
    to: "Aceing her PGDM studies ",
    thumbNail:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205146%20(8).png?updatedAt=1706084293864",
    thumbNail2:
      "https://img.learntube.ai/public-assets/Post%20Payment/Rectangle%205154.png?updatedAt=1706100529885",
  },
];

const constants = {
  Mixpanel: {
    // Landing Page
    LANDING_PAGE: "Landing-Page loaded",
    LANDING_PAGE_GET_STARTED_CLICKED: "Landing-Page Get Start clicked",
    LANDING_PAGE_START_NOW_CLICKED: "Landing-Page Start Now clicked",
    LANDING_PAGE_SEARCH_BY_JOB_INSTEAD:
      "Landing-Page Search by Job Instead clicked",
    SKILL_SELECTION_PAGE: "Skill selection Page loaded",
    COURSE_SELECTION_PAGE: "Category selection Page loaded",
    COURSE_SELECTED_FROM_COURSE_SELECTION_PAGE:
      "Course selected from Category selection page",
    SKILL_SELECTED_FROM_COURSE_SELECTION_PAGE:
      "Skill selected from Category selection page",
    CUSTOM_SKILL_SELECTED_FROM_COURSE_SELECTION_PAGE:
      "Custom Skill selected from Category selection page",
    SKILL_SELECTED_FROM_SKILL_SELECTION_PAGE:
      "Skill selected from Skill selection page",
    CUSTOM_SKILL_SELECTED_FROM_SKILL_SELECTION_PAGE:
      "Custom Skill selected from Skill selection page",
    SKILL_SELECTED_FROM_SEARCH_RESULT: "Skill selected from Search results",
    SKILL_NAME: "Skill was selected",
    SKILL_LEVEL1: "Almost 0 knowledge was clicked",
    SKILL_LEVEL2: "Basic understanding was clicked",
    SKILL_LEVEL3: "Have done some work on it was clicked",
    SKILL_LEVEL4: "Work regularly with it was clicked",

    //  Onboarding Page
    ONBOARDING_PAGE: "Onboarding-Page loaded",
    NAME_ENTERED: "Name was entered",
    ONBOARDING_PAGE_LOADER_SCREEN_1: "Onboarding-Page loader screen 1 loaded",
    ONBOARDING_PAGE_LOADER_SCREEN_2: "Onboarding-Page loader screen 2 loaded",
    ONBOARDING_PAGE_LOADER_SCREEN_3: "Onboarding-Page loader screen 3 loaded",
    ONBOARDING_PAGE_LOADER_SCREEN_4: "Onboarding-Page loader screen 4 loaded",

    //  Questions Page
    QUESTIONS_PAGE: "Questions-Page loaded",
    QUESTION_1_ANSWERED: "Question 1 was answered",
    QUESTION_2_ANSWERED: "Question 2 was answered",
    QUESTION_3_ANSWERED: "Question 3 was answered",
    QUESTION_4_ANSWERED: "Question 4 was answered",
    QUESTION_5_ANSWERED: "Question 5 was answered",
    QUESTION_1_NEXT_BUTTON: "Question 1 back button was clicked",
    QUESTION_2_NEXT_BUTTON: "Question 2 back button was clicked",
    QUESTION_3_NEXT_BUTTON: "Question 3 back button was clicked",
    QUESTION_4_NEXT_BUTTON: "Question 4 back button was clicked",
    QUESTION_5_NEXT_BUTTON: "Question 5 back button was clicked",

    // Analysis Page
    ANALYSIS_PAGE: "Analysis-Page loaded",
    ANALYSIS_STICKY_BUTTON: "Analysis Sticky button was clicked",
    ANALYSIS_NORMAL_BUTTON: "Analysis Normal button was clicked",
    NEW_ANALYSIS_PAGE_LOADER: "Analysis Page New Course Loader Loaded",

    // Register Page
    REGISTER_PAGE: "Register-Page loaded",
    REGISTER_PAGE_PHONE_NUMBER: "Register-Page phone number was entered",
    REGISTER_PAGE_EMAIL: "Register-Page email was entered",
    ANALYSIS_PAGE_LOADER_SCREEN_1: "Analysis-Page loader screen 1 loaded",
    ANALYSIS_PAGE_LOADER_SCREEN_2: "Analysis-Page loader screen 2 loaded",
    ANALYSIS_PAGE_LOADER_SCREEN_3: "Analysis-Page loader screen 3 loaded",
    ANALYSIS_PAGE_LOADER_SCREEN_4: "Analysis-Page loader screen 4 loaded",

    // Course Page
    COURSE_PAGE: "Course-Page loaded",
    COURSE_PAGE_NORMAL_BUTTON: "Course-Page Normal button was clicked",
    COURSE_PAGE_STICKY_BUTTON: "Course-Page Sticky button was clicked",

    // Course and Pricing Page
    COURSE_AND_PRICING_PAGE: "Course and Pricing Page Loaded",
    COURSE_AND_PRICING_PAGE_NORMAL_PAYMENT:
      "Course and Pricing Page Normal Payment Button Was Clicked",
    COURSE_AND_PRICING_PAGE_STICKY_PAYMENT:
      "Course and Pricing Page Sticky Payment Button Was Clicked",
    COURSE_AND_PRICING_PAGE_VIEW_SYLLABUS_BUTTON:
      "Course and Pricing Page View Syllabus Button Was Clicked",

    // Saved Course Page
    SAVED_COURSE_PAGE: "Saved Course-Page loaded",
    SAVED_COURSE_PAGE_NORMAL_BUTTON:
      "Saved Course-Page Normal button was clicked",
    SAVED_COURSE_PAGE_STICKY_BUTTON:
      "Saved Course-Page Sticky button was clicked",

    // Pricing Page
    PRICING_PAGE: "Pricing-Page loaded",
    TAP_1_COURSE: "Tap-on 1 month subscription",
    TAP_2_COURSES: "Tap-on unlimited subscription",
    CLICKED_ON_SCHOLARSHIP: "Pricing page Clicked on scholarship",
    PRICING_PAGE_STICKY_BUTTON_1_COURSE:
      "Pricing-Page Sticky button 1 was clicked",
    PRICING_PAGE_STICKY_BUTTON_2_COURSE:
      "Pricing-Page Sticky button 2 was clicked",
    PRICING_PAGE_NORMAL_BUTTON_1_COURSE:
      "Pricing-Page Normal button 1 was clicked",
    PRICING_PAGE_NORMAL_BUTTON_2_COURSE:
      "Pricing-Page Normal button 2 was clicked",

    // Pricing Page
    PRICING_PAGE_V2: "Pricing-page version 2 loaded",
    CLICKED_ON_SCHOLARSHIP_V2: "Pricing page v2 Clicked on scholarship",
    PRICING_PAGE_STICKY_BUTTON_V2_COURSE:
      "Pricing-Page v2 Sticky button was clicked",
    PRICING_PAGE_NORMAL_BUTTON_V2_COURSE:
      "Pricing-Page v2 Normal button was clicked",
    PRICING_PAGE_ADDITIONAL_FEATURES:
      "Pricing-Page v2 clicked on additional features",
    PRICING_PAGE_FIRST_FEATURES: "Pricing-Page v2 clicked on first feature",
    PRICING_PAGE_SECOND_FEATURES: "Pricing-Page v2 clicked on second feature",
    PRICING_PAGE_PAYMENT_SUCCESSFULL_PAGE:
      "Pricing Page Payment Successful Page loaded",
    PERSONALIZE_PRICING_PAGE_PRO_MEMBERSHIP_SELECTED:
      "Pricing Page Pro Membership Add-On Selected",
    PERSONALIZE_PRICING_PAGE_PLACEMENT_SUPPORT_SELECTED:
      "Pricing Page Placement Support Add-On Selected",
    PERSONALIZE_PRICING_PAGE_PRO_MEMBERSHIP_REMOVED:
      "Pricing Page Pro Membership Add-On Removed",
    PERSONALIZE_PRICING_PAGE_PLACEMENT_SUPPORT_REMOVED:
      "Pricing Page Placement Support Add-On Removed",
    PERSONALIZE_PRICING_PAGE_PLACEMENT_SUPPORT_MODAL_OPENED:
      "Pricing Page Placement Support Modal Opened",
    PERSONALIZE_PRICING_PAGE_COURSE_CATEGORY_MODAL_OPENED:
      "Pricing Page Course Category Modal Opened",
    // Welcome Page
    WELCOME_PAGE: "Welcome page loaded",
    WELCOME_PAGE_BUTTON_CLICKED:
      "Clicked welcome page email submission button clicked",

    // Course List Page
    COURSE_LIST_PAGE: "Course List Page loaded",
    COURSE_LIST_COURSE_DROPDOWN_CLICKED: "Course List dropdown clicked",
    COURSE_LIST_SELECT_COURSE_FROM_DROPDOWN:
      "Course from dropdown was selected",
    COURSE_LIST_PAGE_CLICKED_ON_LESSON:
      "Clicked on a lesson in the course list",
    COURSE_LIST_PAGE_CLICKED_ON_PROJECTS:
      "Clicked on a project in the course list",

    // Lesson Page
    LESSON_PAGE: "Lesson page was loaded",
    LESSON_PAGE_HAMBURGER_WAS_CLICKED:
      "Lesson page hamburger button was clicked",
    LESSON_PAGE_COURSE_CRUMB_CLICKED: "Lesson page course crumb was clicked",
    LESSON_PAGE_LESSON_CRUMB_CLICKED: "Lesson page course crumb was clicked",
    LESSON_PAGE_LESSON_WAS_PLAYED: "Lesson page video was played",
    LESSON_PAGE_USER_GOAL_FROM_KEYTAKEAWAY_WAS_CLICKED:
      "Lesson page user goal was submitted",
    LESSON_PAGE_VOICE_TOGGLE: "Lesson page voice toggle was clicked",
    LESSON_PAGE_USER_GOAL_FROM_QUIZ_WAS_CLICKED:
      "Lesson page user goal was submitted",
    LESSON_PAGE_PRE_DEFINED_DOUBT_WAS_CLICKED:
      "Lesson page predefined doubt was clicked",
    LESSON_PAGE_DOUBT_WAS_ASKED: "Lesson page query was submitted",
    LESSON_PAGE_QUIZ_WAS_SUBMITTED: "Lesson page quiz was submitted",
    LESSON_PAGE_NEXT_LESSON_BUTTON_CLICKED:
      "Lesson page next lesson button was clicked",
    LESSON_PAGE_PREVIOUS_LESSON_BUTTON_CLICKED:
      "Lesson page previous lesson button was clicked",
    LESSON_PAGE_ONBOARDING_COURSE_PURCHASE_SUCCESS:
      "Lesson page onboarding course purchase success",
    LESSON_PAGE_ONBOARDING_COURSE_PURCHASE_BUTTON_CLICKED:
      "Lesson page onboarding course purchase button clicked",

    // Overview Page
    OVERVIEW_PAGE: "Overview page was loaded",
    OVERVIEW_PAGE_LESSON_WAS_CLICKED: "Overview page lesson was clicked",
    OVERVIEW_PAGE_PROJECT_WAS_CLICKED: "Overview page project was clicked",

    // Project Page
    PROJECT_PAGE: "Project page was loaded",
    PROJECT_PAGE_UNLOCK_NOW_CLICKED: "Project page unlock was clicked",

    // Bottom Illustartion
    NORMAL_SCHOLARSHIP_BUTTON:
      "Clicked on normal scholarship button in Project page",
    STICKY_SCHOLARSHIP_BUTTON:
      "Clicked on sticky scholarship button in Project page",
    NORMAL_PAYMENT_BUTTON: "Clicked on normal payment button in Project page",
    STICKY_PAYMENT_BUTTON: "Clicked on sticky payment button in Project page",

    // Learntube X
    NORMAL_LEARNTUBEX_PAYMENT_BUTTON:
      "Clicked on normal payment button in learntube X",
    STICKY_LEARNTUBEX_PAYMENT_BUTTON:
      "Clicked on sticky payment button in learntube X",

    // Course Flow from Onboarding
    ODD_USER_SKILL_LEVEL_PAGE:
      "Onboarding Odd User Skill Level Selection Page Loaded",
    ODD_USER_SKILL_LEVEL_SELECTED:
      "Onboarding Odd User Skill Level Was Selected",
    ODD_USER_QUESTION_PAGE_LOADED: "Onboarding Odd User Question Page Loaded",
    ODD_USER_QUESTION_1_ANSWERED: "Onboarding Odd User Question 1 Was Answered",
    ODD_USER_QUESTION_2_ANSWERED: "Onboarding Odd User Question 2 Was Answered",
    ODD_USER_QUESTION_3_ANSWERED: "Onboarding Odd User Question 3 Was Answered",
    ODD_USER_QUESTION_4_ANSWERED: "Onboarding Odd User Question 4 Was Answered",
    ODD_USER_QUESTION_5_ANSWERED: "Onboarding Odd User Question 5 Was Answered",
    ODD_USER_QUESTION_6_ANSWERED: "Onboarding Odd User Question 6 Was Answered",
    ODD_USER_QUESTION_7_ANSWERED: "Onboarding Odd User Question 7 Was Answered",
    ODD_USER_ANALYSIS_PAGE_LOADED: "Onboarding Odd User Analysis Page Loaded",
    ODD_USER_ANALYSIS_PAGE_NORMAL_BUTTON_CLICKED:
      "Onboarding Odd User Analysis Page Normal Button Clicked",
    ODD_USER_ANALYSIS_PAGE_STICKY_BUTTON_CLICKED:
      "Onboarding Odd User Analysis Page Sticky Button Clicked",
    ODD_USER_COURSE_PAGE_LOADED: "Onboarding Odd User Course Page Loaded",

    EVEN_USER_COURSE_CURATION_PAGE_LOADED:
      "Onboarding Even User Course Curation Page Loaded",

    SKILL_CERTIFICATE_DOWNLOADED: "Skill Certificate Downloaded",
    NEW_LEADERBOARD_PAGE_CERTIFICATE_WAS_DOWNLOADED:
      "New Leaderboard Page Certificate Was Downloaded",

    // OnboardingV2 Flow - Main Pages
    ONBOARDING_V2_STEP1_PAGE_LOADED: "OnboardingV2 Step1 Page Loaded",
    ONBOARDING_V2_STEP1_GOAL_SELECTED: "OnboardingV2 Step1 Goal Selected",
    ONBOARDING_V2_STEP1_ROLE_SUBMITTED: "OnboardingV2 Step1 Role Submitted",
    ONBOARDING_V2_USER_DETAILS_PAGE_LOADED:
      "OnboardingV2 User Details Page Loaded",
    ONBOARDING_V2_USER_DETAILS_FORM_SUBMITTED:
      "OnboardingV2 User Details Form Submitted",
    ONBOARDING_V2_STEP2_PAGE_LOADED: "OnboardingV2 Step2 Page Loaded",
    ONBOARDING_V2_STEP2_EXPERIENCE_LEVEL_SELECTED:
      "OnboardingV2 Step2 Experience Level Selected",
    ONBOARDING_V2_STEP3_PAGE_LOADED: "OnboardingV2 Step3 Page Loaded",
    ONBOARDING_V2_MCQ_PAGE_LOADED: "OnboardingV2 MCQ Page Loaded",
    ONBOARDING_V2_MCQ_QUESTION_ANSWERED: "OnboardingV2 MCQ Question Answered",
    ONBOARDING_V2_MCQ_COMPLETED: "OnboardingV2 MCQ Completed",
    ONBOARDING_V2_ANALYSIS_PAGE_LOADED: "OnboardingV2 Analysis Page Loaded",
    ONBOARDING_V2_ANALYSIS_VIEW_COURSE_CLICKED:
      "OnboardingV2 Analysis View Course Clicked",
    ONBOARDING_V2_PRICING_PAGE_LOADED: "OnboardingV2 Pricing Page Loaded",
    ONBOARDING_V2_PRICING_CTA_CLICKED: "OnboardingV2 Pricing CTA Clicked",
    ONBOARDING_V2_PRICING_STICKY_CTA_CLICKED:
      "OnboardingV2 Pricing Sticky CTA Clicked",
    ONBOARDING_V2_PRICING_SYLLABUS_EXPANDED:
      "OnboardingV2 Pricing Syllabus Expanded",
    ONBOARDING_V2_PAYMENT_SUCCESS_PAGE_LOADED:
      "OnboardingV2 Payment Success Page Loaded",

    // OnboardingV2 Loaders
    ONBOARDING_V2_LOADER_ONE_LOADED: "OnboardingV2 Loader One Loaded",
    ONBOARDING_V2_LOADER_TWO_LOADED: "OnboardingV2 Loader Two Loaded",
    ONBOARDING_V2_LOADER_THREE_LOADED: "OnboardingV2 Loader Three Loaded",
    ONBOARDING_V2_LOADER_FOUR_LOADED: "OnboardingV2 Loader Four Loaded",

    // OnboardingV2 User Interactions
    ONBOARDING_V2_FORM_FIELD_FOCUSED: "OnboardingV2 Form Field Focused",
    ONBOARDING_V2_COUNTRY_CODE_CHANGED: "OnboardingV2 Country Code Changed",
    ONBOARDING_V2_FAQ_OPENED: "OnboardingV2 FAQ Opened",
    ONBOARDING_V2_TESTIMONIAL_VIEWED: "OnboardingV2 Testimonial Viewed",

    // PlacementModal Events
    ONBOARDING_V2_PLACEMENT_MODAL_OPENED: "OnboardingV2 Placement Modal Opened",
    ONBOARDING_V2_PLACEMENT_MODAL_CLOSED: "OnboardingV2 Placement Modal Closed",
    ONBOARDING_V2_PLACEMENT_VIDEO_CLICKED:
      "OnboardingV2 Placement Video Clicked",
    ONBOARDING_V2_PLACEMENT_VIDEO_PLAYER_OPENED:
      "OnboardingV2 Placement Video Player Opened",
    ONBOARDING_V2_PLACEMENT_VIDEO_PLAYER_BACK:
      "OnboardingV2 Placement Video Player Back",

    // Cancellation Modal Events
    ONBOARDING_V2_CANCELLATION_MODAL_OPENED:
      "OnboardingV2 Cancellation Modal Opened",
    ONBOARDING_V2_CANCELLATION_MODAL_CLOSED:
      "OnboardingV2 Cancellation Modal Closed",
    ONBOARDING_V2_CANCELLATION_MODAL_CONTINUE_CLICKED:
      "OnboardingV2 Cancellation Modal Continue Clicked",
    ONBOARDING_V2_CANCELLATION_MODAL_TIMER_EXPIRED:
      "OnboardingV2 Cancellation Modal Timer Expired",

    // Role Flow Events
    ROLE_SEARCH_PAGE_LOADED: "Role Search Page Loaded",
    ROLE_SEARCH_INPUT_FOCUSED: "Role Search Input Focused",
    ROLE_SEARCH_QUERY_TYPED: "Role Search Query Typed",
    ROLE_SEARCH_POPULAR_ROLE_CLICKED: "Role Search Popular Role Clicked",
    ROLE_SEARCH_DROPDOWN_RESULT_CLICKED: "Role Search Dropdown Result Clicked",
    ROLE_SEARCH_FORM_SUBMITTED: "Role Search Form Submitted",
    ROLE_SEARCH_SHOW_MORE_CLICKED: "Role Search Show More Clicked",
    ROLE_SEARCH_VIEW_LESS_CLICKED: "Role Search View Less Clicked",

    ROLE_SKILLS_PAGE_LOADED: "Role Skills Page Loaded",
    ROLE_SKILLS_SKILL_SELECTED: "Role Skills Skill Selected",
    ROLE_SKILLS_SKILL_DESELECTED: "Role Skills Skill Deselected",
    ROLE_SKILLS_START_PERSONALIZATION_CLICKED:
      "Role Skills Start Personalization Clicked",
    ROLE_SKILLS_API_ERROR: "Role Skills API Error",
    ROLE_SKILLS_RETRY_CLICKED: "Role Skills Retry Clicked",

    // OnboardingV2 Step4 Events
    ONBOARDING_V2_STEP4_PAGE_LOADED: "OnboardingV2 Step4 Page Loaded",
    ONBOARDING_V2_STEP4_TIMELINE_SELECTED:
      "OnboardingV2 Step4 Timeline Selected",
    ONBOARDING_V2_STEP4_WEEKLY_HOURS_CHANGED:
      "OnboardingV2 Step4 Weekly Hours Changed",
    ONBOARDING_V2_STEP4_CONTINUE_CLICKED: "OnboardingV2 Step4 Continue Clicked",

    // OnboardingV2 Step3 Events
    ONBOARDING_V2_STEP3_PAGE_LOADED: "OnboardingV2 Step3 Page Loaded",
    ONBOARDING_V2_STEP3_BEGINNER_OPTION_SELECTED:
      "OnboardingV2 Step3 Beginner Option Selected",
    ONBOARDING_V2_STEP3_SKILL_CARD_EXPANDED:
      "OnboardingV2 Step3 Skill Card Expanded",
    ONBOARDING_V2_STEP3_SKILL_CARD_COLLAPSED:
      "OnboardingV2 Step3 Skill Card Collapsed",
    ONBOARDING_V2_STEP3_SKILL_LEVEL_RATED:
      "OnboardingV2 Step3 Skill Level Rated",
    ONBOARDING_V2_STEP3_CONTINUE_CLICKED: "OnboardingV2 Step3 Continue Clicked",
    ONBOARDING_V2_STEP3_SKILL_CHECK_CLICKED:
      "OnboardingV2 Step3 Skill Check Clicked",

    ONBOARDING_V2_PRICING_COURSE_PURCHASE_SUCCESS:
      "OnboardingV2 Pricing Course Purchase Success",
    ONBOARDING_V2_PRICING_COURSE_PURCHASE_FAILED:
      "OnboardingV2 Pricing Course Purchase Failed",

    ONBOARDING_V2_PRICING_PAGE_COUPON_APPLIED:
      "OnboardingV2 Pricing Page Coupon Applied",

    ONBOARDING_V2_COURSE_UNLOCK_NOW_CLICKED:
      "OnboardingV2 Course Unlock Now Clicked",
    //onboardingv2
  },
};

export const capitalise = (str = "") => {
  if (str === "") return "";
  return str?.[0].toUpperCase() + str?.slice(1);
};

export function epochToCustomFormat(epochTime) {
  const dateObj = new Date(epochTime * 1000);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = months[dateObj.getMonth()];
  const hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;

  const customFormat = `${day} ${month}, ${formattedHours}:${minutes}${ampm}`;
  return customFormat;
}

export function removeWords(str) {
  const wordsToRemove = [
    "advanced",
    "basic",
    "(English)",
    "programming",
    "intermediate",
    "(Basic)",
    "(Telugu)",
    "(Tamil)",
    "(Hindi)",
  ];

  let result = str;
  wordsToRemove.forEach((word) => {
    const escapedWord = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    // If word contains non-word characters like ( or ), don't use \b
    const useBoundary = /^[a-zA-Z0-9]+$/.test(word);

    const pattern = useBoundary ? `\\b${escapedWord}\\b` : escapedWord;
    const regex = new RegExp(pattern, "gi");

    result = result
      .replace(regex, "")
      .replace(/\s{2,}/g, " ")
      .trim();
  });

  return result;
}

export const years = [
  {
    id: 0,
    year: "1 Year",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/1year.svg?updatedAt=1685861204276",
    desktopImage:
      "https://img.learntube.ai/public-assets/LinkdinUsers/Group%209867.svg?updatedAt=1701946377474",
  },
  {
    id: 1,
    year: "3 Year",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/3year.svg?updatedAt=1685861189080",
    desktopImage:
      "https://img.learntube.ai/public-assets/LinkdinUsers/Group%209866.svg?updatedAt=1701946377143",
  },
  {
    id: 2,
    year: "5 Year",
    image:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/5year.svg?updatedAt=1685861155995",
    desktopImage:
      "https://img.learntube.ai/public-assets/LinkdinUsers/Group%209860.svg?updatedAt=1701946377253",
  },
];

export const faqs = [
  {
    id: 0,
    question: "How is this course personalised for me?",
    answer:
      "Our domain experts (with 30+ years of combined experience) along with our AI engine analyse your skills, goals & answers to identify what you need to learn. We then build a detailed syllabus accordingly for you. And the personalisation doesn’t end here. Once you start learning, your course will be further personalised to you as per your needs.",
  },
  {
    id: 1,
    question: "What all courses do you offer?",
    answer:
      "Our personalisation technology works across domains, from career skills like Java to even hobbies like baking. Most users use us to learn work related skills in the domain of Programming, Marketing, Data Science, Design, Business & lots of different tools.",
  },
  {
    id: 2,
    question: "Does the course really help in jobs?",
    answer:
      "Yess! If you learn properly, do your assessments & projects and then showcase your skills in your CV & portfolio to employers it will make a huge difference in your job applications & even your own confidence. Our learners work at top companies from Amazon to TCS and many have gone on to become freelancers & entrepreneurs.",
  },
  {
    id: 3,
    question: "Does LearnTube make the content too?",
    answer:
      "We make personalised, certified courses. We do not make the videos in the course. Those are sourced from across the internet to make sure we get the very best content for you. Most videos are from top YouTube creators. We do the hard work of figuring out what you need to learn, finding the very best videos for it, arranging it in the best order, assessing your skills, solving your doubts, giving you projects to do & then certifying you.",
  },
  {
    id: 4,
    question: "How do I get certified?",
    answer:
      "Once you complete the course & assessments you will get certified immediately. Our certificate is recognised by hundreds of companies.",
  },
  {
    id: 5,
    question: "Is there any refund policy?",
    answer:
      "There sure is. While completing your course, if you find a cheaper, more personalised course than ours you will get your money back! Just reach out to us within 7 days of purchase with the details on hello@careerninja.in",
  },
];

export const pricingFaqs = [
  {
    id: 0,
    question: "Is this a monthly subscription or one-time payment?",
    answer:
      "This is a monthly subscription that gives you full access while your plan is active. No long-term lock-in — you can cancel anytime.",
  },
  {
    id: 1,
    question: "Is this course really personalised for me?",
    answer:
      "Yes. Before creating your course, we understand your goal, experience level, learning pace, and onboarding answers to build a path that fits where you are right now. Our domain experts (30+ years of combined experience) and AI engine then create a syllabus focused on what you need most — helping you avoid unnecessary topics and learn faster. And the personalisation doesn’t stop there. As you continue learning, your course keeps adapting based on your progress and needs.",
  },
  {
    id: 2,
    question: "What do I get with unlimited access?",
    answer:
      "Along with your personalised course, you get access to 3174+ courses while your subscription is active. You’ll also get hands-on projects, and curated learning content during your active plan.",
  },
  {
    id: 3,
    question: "What makes this more valuable than free YouTube content?",
    answer: `The real problem isn’t lack of content — it’s too much scattered content. Finding the right videos, in the right order, for your exact goal can take hours and often leads to confusion. We curate the best videos from top creators, organise them into a structured and personalised learning path, and combine them with projects, resources, and clear progression so you know exactly what to learn next. Instead of wasting time searching, comparing, and guessing, you get a ready roadmap built for your goal.`,
  },
  {
    id: 4,
    question: "How do I get certified?",
    answer:
      "Once you complete the course & assessments you will get certified immediately. Our certificate is recognised by 1100+ leading companies.",
  },
  {
    id: 5,
    question: "Can I cancel anytime?",
    answer:
      "Yes. You can cancel your subscription anytime. You’ll continue to have access until your current billing period ends.",
  },
  {
    id: 6,
    question: "Is there any refund policy?",
    answer:
      "There sure is. While completing your course, if you find a cheaper, more personalised course than ours you will get your money back! Just reach out to us within 7 days of purchase with the details on hello@careerninja.in",
  },
];

export const placementData = [
  {
    label: "Week 1",
    title: "Building the Ultimate Profile",
    subtitle: "CV + LinkedIn revamp to make your application stand out",
    video_link: "https://youtu.be/OKVe7qahDoc",
    thumbnail:
      "https://img.learntube.ai/public-assets/Optimized_folder/premium/placementImages/week-1.jpg?updatedAt=1688366093369",
  },
  {
    label: "Week 2",
    title: "Creating Your Job Hunt Plan",
    subtitle: "Learn winning strategies that will get you shortlisted",
    video_link: "https://youtu.be/93Y-_Pzk7SM",
    thumbnail:
      "https://img.learntube.ai/public-assets/Optimized_folder/premium/placementImages/week-2.jpg?updatedAt=1688366094136",
  },
  {
    label: "Week 3",
    title: "Mastering The Elevator Pitch",
    subtitle: "Land multiple job interviews with the right skills & attitude",
    video_link: "https://youtu.be/Oa73QfUg9WI",
    thumbnail:
      "https://img.learntube.ai/public-assets/Optimized_folder/premium/placementImages/week-3.jpg?updatedAt=1688366094579",
  },
  {
    label: "Week 4",
    title: "Live Interview Training",
    subtitle: "Get hired with mock interviews & personalised feedback",
    video_link: "https://youtu.be/AKUVJT7UYl0",
    thumbnail:
      "https://img.learntube.ai/public-assets/Optimized_folder/premium/placementImages/week-4.jpg?updatedAt=1688366094496",
  },
];

export const report = [
  {
    id: 1,
    name: "Video Problem",
    subtitle: "Blurry, cuts out, or looks strange in some way.",
  },
  {
    id: 2,
    name: "Sound Problem",
    subtitle: "Hard to hear, not matched with video, or missing in some partts",
  },
  {
    id: 1,
    name: "Subtitles or Caption Problem",
    subtitle:
      "Missing, hard to read, not matched with sound, misspellings, or poor translations.",
  },
];

export const qualityLevel = [
  [0, 10, 10],
  [10, 20, 30],
  [20, 30, 40],
  [30, 40, 50],
];

export const qualityLevel2 = [1, 2, 3];

export const questions = [
  {
    id: 0,
    question: "What is the difference between UI/UX design?",
  },
  {
    id: 1,
    question: "What is the difference between UI/UX design?",
  },
  {
    id: 2,
    question: "What is the difference between UI/UX design?",
  },
  {
    id: 3,
    question: "What is the difference between UI/UX design?",
  },
  {
    id: 4,
    question: "What is the difference between UI/UX design?",
  },
];

export const questionsTag = [
  "86% people who completed this quiz got hired",
  "93% users loved their feedback & course",
  "93% users loved their feedback & course",
  "88% quiz takers felt more confident on completing",
  "70% Users Got Hired Who Completed This Quiz",
];

export const images = [
  "https://img.learntube.ai/public-assets/Learntube/Group_8427-modified.png?updatedAt=1688826368148",
  "https://img.learntube.ai/public-assets/Learntube/Group_8427__1_-modified.png?updatedAt=1688826500580",
  "https://img.learntube.ai/public-assets/Learntube/Group_8427__2_-modified.png?updatedAt=1688826589078",
  "https://img.learntube.ai/public-assets/Learntube/Group_8427__3_-modified.png?updatedAt=1688826667584",
  "https://img.learntube.ai/public-assets/Learntube/Group_8427__4_-modified.png?updatedAt=1688826759338",
  "https://img.learntube.ai/public-assets/Learntube/Group_8427__4_-modified.png?updatedAt=1688826759338",
  "https://img.learntube.ai/public-assets/Learntube/Group_8427__4_-modified.png?updatedAt=1688826759338",
];

export const projects = [
  {
    id: 1,
    mentor: "Rahila Saleem",
    domain_icon:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-1/digital-marketing.png?updatedAt=1686737716822",
    domain: "Digital Marketing",
    project_thumbnail:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/thumbnails/digital-marketing-project-thumbnail.png?updatedAt=1686737808692",
    title: "Creating a Social Media Campaign for a Product Launch",
    description:
      "The objective of this project is to create and execute a comprehensive social media campaign to generate buzz, drive engagement, and increase sales for a new product launch.",
    skills_showcase: [
      "Social media strategy development",
      "Content creation and curation",
      "Social media advertising",
      "Analytics and reporting",
      "Project management",
    ],
    tools_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-1/Canva_-_png_0.png?updatedAt=1686750058981",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-1/google_analytics.png?updatedAt=1686750063138",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-1/Hootsuite_-_png_0.png?updatedAt=1686750064611",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-1/instagram.png?updatedAt=1686750058966",
    ],
    companies_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-1/Gazoop_-_png_0.png?updatedAt=1686750059167",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-1/ogilvy.png?updatedAt=1686750062352",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-1/publicis_groupe.png?updatedAt=1686750059164",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-1/Schbang_-_jpeg_0.png?updatedAt=1686750058978",
    ],
    download_link:
      "https://drive.google.com/file/d/1ap6selIs8LiW6tjPOd6poCyrJb5l031d/view?usp=drive_link",
  },
  {
    id: 2,
    mentor: "Dushyant Pathak",
    domain: "Programming",
    domain_icon:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-2/programming.png?updatedAt=1686737693833",
    project_thumbnail:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/thumbnails/programming-project-thumbnail.png?updatedAt=1686737808024",
    title:
      "Building an E-commerce Platform with Payment Integration and User Authentication",
    description:
      "The objective of this project is to develop a functional e-commerce platform that allows users to browse and purchase products and integrates secure payment processing.",
    skills_showcase: [
      "Web development (HTML, CSS, JavaScript)",
      "Backend development using NodeJs",
      "Database management (MySQL, PostgreSQL)",
      "Payment gateway integration (Stripe, PayPal)",
      "User authentication and authorization",
    ],
    tools_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-2/Node.js_-_png_0.png?updatedAt=1686750420514",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-2/Oracle_MySQL_-_png_0.png?updatedAt=1686750420884",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-2/Stripe_-_png_0.png?updatedAt=1686750420468",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-2/Adobe_XD_Elements_-_png_0.png?updatedAt=1686750420189",
    ],
    companies_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-2/Wipro_-_png_0.png?updatedAt=1686750486201",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-2/IBM_-_jpeg_0__1_.png?updatedAt=1686750406617",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-2/Stripe_-_png_1.png?updatedAt=1686750404814",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-2/jp_morgan_chase.png?updatedAt=1686750398583",
    ],
    download_link:
      "https://drive.google.com/file/d/1ucbxVGTxi4kWkTthrbJ2WWPFI0V3PEI6/view?usp=drive_link",
  },
  {
    id: 3,
    mentor: "Anirban Paul",
    domain: "Data Science",
    domain_icon:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-3/data-science.png?updatedAt=1686737743114",
    project_thumbnail:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/thumbnails/data-science-project-thumbnail.png?updatedAt=1686737808493",
    title: "Building a Predictive Model for Stock Price Forecasting",
    description:
      "The objective of this project is to develop a predictive model that can forecast stock prices or market trends based on historical data. The model will help investors and traders make informed decisions by providing insights into potential price movements.",
    skills_showcase: [
      "Analysing and visualising trends and patterns",
      "Feature engineering using Python libraries",
      "Selecting and training time series models like ARIMA or LSTM",
      "Evaluating model performance and refining predictions with metrics and optimization techniques",
      "Python for data manipulation and analysis",
    ],
    tools_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-3/Python_Software_Foundation_-_png_0.png?updatedAt=1686750875757",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-3/pandas.png?updatedAt=1686750875758",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-3/matplotlib.png?updatedAt=1686750919583",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-3/alpha_vantage__1_.png?updatedAt=1686750875760",
    ],
    companies_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-3/Amazon_-_png_0.png?updatedAt=1686750875778",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-3/Deloitte_-_png_0.png?updatedAt=1686750875705",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-3/cloudera.png?updatedAt=1686750875592",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-3/Microsoft_-_png_0.png?updatedAt=1686750875711",
    ],
    download_link:
      "https://drive.google.com/file/d/1he-WBEONlpz0J_usyGDAOahfv4hXcSsQ/view?usp=drive_link",
  },
  {
    id: 4,
    mentor: "Dulab Deb",
    domain: "Design",
    domain_icon:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-4/design.png?updatedAt=1686737764588",
    project_thumbnail:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/thumbnails/design-project-thumbnail.png?updatedAt=1686737808572",
    title: "Designing an Engaging User Onboarding Experience",
    description:
      "The objective of this project is to create a user onboarding system which incorporates an easy payment system and also facilitates early product adoption through suggestive content strategy.",
    skills_showcase: [
      "User Experience Design Principles",
      "Interaction Design Techniques",
      "Content Strategy and Personalization",
      "Information Architecture Planning and Organization",
      "Usability Testing and User Research",
    ],
    tools_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-4/Figma_-_png_0.png?updatedAt=1686751222952",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-4/UserTesting_-_png_0.png?updatedAt=1686751223507",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-4/InVision_-_png_0.png?updatedAt=1686751223091",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-4/Adobe_XD_Elements_-_png_6.png?updatedAt=1686751223447",
    ],
    companies_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-4/Tata_Consultancy_Services_-_png_0.png?updatedAt=1686751223490",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-4/popxo.png?updatedAt=1686751223103",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-4/Flipkart_-_png_1.png?updatedAt=1686751280597",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-4/Disney__Hotstar_-_png_0__1_.png?updatedAt=1686751222924",
    ],
    download_link:
      "https://drive.google.com/file/d/1N-MNPtlPvSVn_fiC50KsvInUhYz_o8gv/view?usp=drive_link",
  },
  {
    id: 5,
    mentor: "Rishita Motwani",
    domain: "Finance",
    domain_icon:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-5/finance.png?updatedAt=1686737784270",
    project_thumbnail:
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/thumbnails/finance-project-thumbnail.png?updatedAt=1686737808180",
    title: "Financial Risk Management: Mitigating Risks for a Product Launch",
    description:
      "The objective of this project is to do a financial risk mitigation for a new car launch for a car manufacturer. This will help the business to take informed decisions and avoid losses due to unforeseen risks during project implementation.",
    skills_showcase: [
      "Risk Assessment and Analysis Techniques",
      "Project Planning and Scheduling",
      "Data Analysis for Risk Evaluation",
      "Decision-making under Uncertainty",
      "Project Risk Mitigation Strategies",
    ],
    tools_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-5/excel.png?updatedAt=1686751624475",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-5/ms_powerpointt.png?updatedAt=1686751624127",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-5/ms_projects.png?updatedAt=1686751624108",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-5/tableau.png?updatedAt=1686751684136",
    ],
    companies_showcase: [
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-5/jp_morgan__1_.png?updatedAt=1686751622177",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-5/KPMG_-_png_0.png?updatedAt=1686751621593",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-5/EY_-_png_0.png?updatedAt=1686751684132",
      "https://img.learntube.ai/public-assets/AI_Syllabus_generator/project-5/Deutsche_Bank_-_png_0__1_.png?updatedAt=1686751621587",
    ],
    download_link:
      "https://docs.google.com/spreadsheets/d/1N_fYO8P6YSLB31tfHYxaZ0WNrASgp7d0/edit?usp=share_link&ouid=111942812402022720730&rtpof=true&sd=true",
  },
];

export const videoThumbnail = [
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8553.png?updatedAt=1686917725183",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8549.png?updatedAt=1686917725222",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8550.png?updatedAt=1686917725363",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8547.png?updatedAt=1686917725406",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8551.png?updatedAt=1686917725508",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8552.png?updatedAt=1686917725668",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8548.png?updatedAt=1686917725742",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8546.png?updatedAt=1686917725828",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8545.png?updatedAt=1686917725891",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Group_8533.png?updatedAt=1686917725959",
];

export const placementFeatures = [
  {
    id: 1,
    description: "Monthly Live 1:1 Session With Expert Mentor",
    price: 499,
  },
  {
    id: 2,
    description: "4 Week Ultimate Placement Support Bootcamp (Live)",
    price: 999,
  },
];

export const newCourseLearners = [
  "https://img.learntube.ai/public-assets/About-us/Group%208636.png?updatedAt=1694093041004",
  "https://img.learntube.ai/public-assets/About-us/Group%208637.png?updatedAt=1694093178562",
  "https://img.learntube.ai/public-assets/About-us/Group%208669.png?updatedAt=1694093224644",
  "https://img.learntube.ai/public-assets/About-us/Group%208670.png?updatedAt=1694093279640",
  "https://img.learntube.ai/public-assets/About-us/Group%208671.png?updatedAt=1694093328166",
  "https://img.learntube.ai/public-assets/About-us/Group%208672.png?updatedAt=1694093377219",
  "https://img.learntube.ai/public-assets/About-us/Group%208673.png?updatedAt=1694093421347",
  "https://img.learntube.ai/public-assets/About-us/Group%208674.png?updatedAt=1694093468176",
  "https://img.learntube.ai/public-assets/About-us/Group%208675.png?updatedAt=1694093528618",
  "https://img.learntube.ai/public-assets/About-us/Group%208676.png?updatedAt=1694093572849",
  "https://img.learntube.ai/public-assets/About-us/Group%208677.png?updatedAt=1694093615462",
  "https://img.learntube.ai/public-assets/About-us/Group%208678.png?updatedAt=1694093659965",
  "https://img.learntube.ai/public-assets/About-us/Group%208679.png?updatedAt=1694093776995",
  "https://img.learntube.ai/public-assets/About-us/Group%208680.png?updatedAt=1694093840269",
  "https://img.learntube.ai/public-assets/About-us/Group%208681.png?updatedAt=1694093910102",
];

export const companyIcons = [
  "https://img.learntube.ai/public-assets/dataschool/image%20340.png?updatedAt=1707912130704",
  "https://img.learntube.ai/public-assets/dataschool/image%20343.png?updatedAt=1707912130707",
  "https://img.learntube.ai/public-assets/dataschool/image%20344.png?updatedAt=1707912130695",
  "https://img.learntube.ai/public-assets/dataschool/image%20345.png?updatedAt=1707912130762",
  "https://img.learntube.ai/public-assets/dataschool/Paytm%20-%20jpeg%200.png?updatedAt=1707912130698",
];

export const awardImages = [
  "https://img.learntube.ai/public-assets/dataschool/Group%206958.png?updatedAt=1706766402385",
  "https://img.learntube.ai/public-assets/dataschool/Group%206957.png?updatedAt=1706766437112",
  "https://img.learntube.ai/public-assets/dataschool/Group%208565%20(1).png?updatedAt=1706766562421",
  "https://img.learntube.ai/public-assets/dataschool/Group%208566.png?updatedAt=1706766494185",
  "https://img.learntube.ai/public-assets/dataschool/Group%208725.png?updatedAt=1706766634560",
];

export const secondAwardImages = [
  "https://img.learntube.ai/public-assets/dataschool/image%20463.png?updatedAt=1706767896796",
  "https://img.learntube.ai/public-assets/dataschool/image%209.png?updatedAt=1706768005126",
  "https://img.learntube.ai/public-assets/dataschool/image%20464.png?updatedAt=1706768044081",
  "https://img.learntube.ai/public-assets/dataschool/image%20566.png?updatedAt=1706768131369",
];

export const features = [
  "Personalised Syllabus",
  "Verified Certifications",
  "Practical Projects",
  "Live Doubt Solving",
  "Unlimited Courses & Learning",
];

export const skills = [
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/router-94311.png?updatedAt=1688727084011",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/mobile-94304.png?updatedAt=1688727085080",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/international-94303.png?updatedAt=1688727086351",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/device-94309.png?updatedAt=1688727083691",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/communication-94300.png?updatedAt=1688727083586",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/connection-94295.png?updatedAt=1688727083576",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/configure-94308.png?updatedAt=1688727083711",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/folder-94302.png?updatedAt=1688727083658",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/communication-94297.png?updatedAt=1688727083019",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94305.png?updatedAt=1688727079684",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94307.png?updatedAt=1688727079751",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/chip-94294.png?updatedAt=1688727079774",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/access-94298.png?updatedAt=1688727079504",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/access-94292.png?updatedAt=1688727079556",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94306.png?updatedAt=1688727079443",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94293.png?updatedAt=1688727079369",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/blueprint-94357.png?updatedAt=1688727494104",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/backup-94310.png?updatedAt=1688727079205",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cogwheel-94296.png?updatedAt=1688727079230",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/chart-94299.png?updatedAt=1688727078984",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/atom-101491.png?updatedAt=1688726932512",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/biology-101476.png?updatedAt=1688726932836",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/atom-101488.png?updatedAt=1688726932206",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/biohazard-101494.png?updatedAt=1688726932343",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/explore-101477.png?updatedAt=1688726937840",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/earth-101473.png?updatedAt=1688726937920",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/experiment-101490.png?updatedAt=1688726937682",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/danger-101479.png?updatedAt=1688726936884",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/vector-101475.png?updatedAt=1688726936707",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/design-101474.png?updatedAt=1688726936750",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/chip-101493.png?updatedAt=1688726936588",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/clipboard-101485.png?updatedAt=1688726936464",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/chemistry-101482.png?updatedAt=1688726936501",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/bulb-101472.png?updatedAt=1688726936304",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/api-94353.png?updatedAt=1688727493533",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/brainstorming-94359.png?updatedAt=1688727493618",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/app-94355.png?updatedAt=1688727493256",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/blueprint-94357.png?updatedAt=1688727494104",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/bezier-94361.png?updatedAt=1688727494019",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/strip-94370.png?updatedAt=1688727498391",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/design-94366.png?updatedAt=1688727498170",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/diagram-94367.png?updatedAt=1688727498311",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/idea-94369.png?updatedAt=1688727498258",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/design-94364.png?updatedAt=1688727498157",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/work-94371.png?updatedAt=1688727498065",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/compass-94362.png?updatedAt=1688727498013",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/router-94311.png?updatedAt=1688727084011",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/mobile-94304.png?updatedAt=1688727085080",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/international-94303.png?updatedAt=1688727086351",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/device-94309.png?updatedAt=1688727083691",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/communication-94300.png?updatedAt=1688727083586",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/connection-94295.png?updatedAt=1688727083576",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/configure-94308.png?updatedAt=1688727083711",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/folder-94302.png?updatedAt=1688727083658",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/communication-94297.png?updatedAt=1688727083019",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94305.png?updatedAt=1688727079684",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94307.png?updatedAt=1688727079751",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/chip-94294.png?updatedAt=1688727079774",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/access-94298.png?updatedAt=1688727079504",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/access-94292.png?updatedAt=1688727079556",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94306.png?updatedAt=1688727079443",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94293.png?updatedAt=1688727079369",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/blueprint-94357.png?updatedAt=1688727494104",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/backup-94310.png?updatedAt=1688727079205",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cogwheel-94296.png?updatedAt=1688727079230",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/chart-94299.png?updatedAt=1688727078984",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/atom-101491.png?updatedAt=1688726932512",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/biology-101476.png?updatedAt=1688726932836",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/atom-101488.png?updatedAt=1688726932206",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/biohazard-101494.png?updatedAt=1688726932343",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/explore-101477.png?updatedAt=1688726937840",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/earth-101473.png?updatedAt=1688726937920",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/experiment-101490.png?updatedAt=1688726937682",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/danger-101479.png?updatedAt=1688726936884",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/vector-101475.png?updatedAt=1688726936707",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/design-101474.png?updatedAt=1688726936750",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/chip-101493.png?updatedAt=1688726936588",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/clipboard-101485.png?updatedAt=1688726936464",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/chemistry-101482.png?updatedAt=1688726936501",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/bulb-101472.png?updatedAt=1688726936304",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/api-94353.png?updatedAt=1688727493533",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/brainstorming-94359.png?updatedAt=1688727493618",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/app-94355.png?updatedAt=1688727493256",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/blueprint-94357.png?updatedAt=1688727494104",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/bezier-94361.png?updatedAt=1688727494019",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/strip-94370.png?updatedAt=1688727498391",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/design-94366.png?updatedAt=1688727498170",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/diagram-94367.png?updatedAt=1688727498311",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/idea-94369.png?updatedAt=1688727498258",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/design-94364.png?updatedAt=1688727498157",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/work-94371.png?updatedAt=1688727498065",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/compass-94362.png?updatedAt=1688727498013",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/router-94311.png?updatedAt=1688727084011",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/mobile-94304.png?updatedAt=1688727085080",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/international-94303.png?updatedAt=1688727086351",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/infrastructure-94301.png?updatedAt=1688727083984",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/device-94309.png?updatedAt=1688727083691",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/communication-94300.png?updatedAt=1688727083586",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/connection-94295.png?updatedAt=1688727083576",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/configure-94308.png?updatedAt=1688727083711",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/folder-94302.png?updatedAt=1688727083658",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/communication-94297.png?updatedAt=1688727083019",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94305.png?updatedAt=1688727079684",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94307.png?updatedAt=1688727079751",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/chip-94294.png?updatedAt=1688727079774",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/access-94298.png?updatedAt=1688727079504",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/access-94292.png?updatedAt=1688727079556",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94306.png?updatedAt=1688727079443",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cloud-94293.png?updatedAt=1688727079369",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/blueprint-94357.png?updatedAt=1688727494104",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/backup-94310.png?updatedAt=1688727079205",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/cogwheel-94296.png?updatedAt=1688727079230",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-2/chart-94299.png?updatedAt=1688727078984",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/atom-101491.png?updatedAt=1688726932512",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/biology-101476.png?updatedAt=1688726932836",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/atom-101488.png?updatedAt=1688726932206",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/biohazard-101494.png?updatedAt=1688726932343",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/explore-101477.png?updatedAt=1688726937840",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/earth-101473.png?updatedAt=1688726937920",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/experiment-101490.png?updatedAt=1688726937682",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/danger-101479.png?updatedAt=1688726936884",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/vector-101475.png?updatedAt=1688726936707",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/design-101474.png?updatedAt=1688726936750",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/chip-101493.png?updatedAt=1688726936588",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/clipboard-101485.png?updatedAt=1688726936464",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/chemistry-101482.png?updatedAt=1688726936501",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube/bulb-101472.png?updatedAt=1688726936304",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/api-94353.png?updatedAt=1688727493533",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/brainstorming-94359.png?updatedAt=1688727493618",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/app-94355.png?updatedAt=1688727493256",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/blueprint-94357.png?updatedAt=1688727494104",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/bezier-94361.png?updatedAt=1688727494019",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/strip-94370.png?updatedAt=1688727498391",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/design-94366.png?updatedAt=1688727498170",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/diagram-94367.png?updatedAt=1688727498311",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/idea-94369.png?updatedAt=1688727498258",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/design-94364.png?updatedAt=1688727498157",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/work-94371.png?updatedAt=1688727498065",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/compass-94362.png?updatedAt=1688727498013",
  "https://img.learntube.ai/public-assets/AI_Syllabus_generator/Learntube-5/coding-94363.png?updatedAt=1688727497968",
];

export const popularSkillsFromCategories = {
  "programming-courses": {
    name: "Programming",
    skills: [
      "Java",
      "HTML",
      "C Programming",
      "C++",
      "Java Advanced",
      "JavaScript Basic",
      "Data Structure & Algorithm",
      "Bootstrap",
      "React JS",
      "JavaScript Advanced",
      "PHP",
      "CSS",
      "Android App Development",
      "Django (Basic)",
      "C#",
      "Node.JS",
      "Laravel",
      "Flutter",
      "DSA in Java",
      "Angular JS",
      "DSA With JavaScript",
      "SpringBoot",
      "Django Advanced",
      "PostgreSQL",
      "System Design",
      "Devops",
      "Kotlin",
      "Express JS",
      "Webflow For Website Creation",
      "MATLAB",
      "Flask",
      "Django Basic",
      "C# Advanced",
      "Object Oriented Analysis",
      "Game Development",
      "TensorFlow",
      "Redux",
      "jQuery",
      "Spring Framework",
      "CodeIgniter",
      "Next.js",
    ],
  },
  "digital-marketing-courses": {
    name: "Digital Marketing",
    skills: [
      "Digital Marketing",
      "Social Media Marketing",
      "SEO",
      "Affiliate Marketing",
      "Content Writing",
      "Content Marketing",
      "Search Engine Marketing",
      "Google Analytics",
      "Email Marketing",
      "Web Analytics",
      "Display Advertisements",
      "Lead Generation",
      "Branding & Design Essentials",
      "Influencer Marketing",
      "AI Social Media Mastery",
      "Paid Ads & Paid Media",
      "Drop Shipping",
      "AI Content Mastery",
      "Copywriting",
      "CRM & Community Building",
      "Reel Making",
      "Account Management & Client Servicing",
      "Remarketing & Growth Hacking",
    ],
  },
  "data-science-analytics-courses": {
    name: "Data Science & Analytics",
    skills: [
      "Python Basic",
      "Data Analytics",
      "Python Advanced",
      "Power BI Basic",
      "Machine Learning",
      "Power BI Advanced",
      "Applied Artificial Intelligence",
      "Mastering ChatGPT",
      "R Programming",
      "Tableau Basic",
      "Deep Learning",
      "Statistical Modelling",
      "Tableau Advanced",
      "Artificial Intelligence",
      "Generative AI",
      "Prompt Engineering",
      "Data Architecture with Python",
      "GDPR",
    ],
  },
  "uiux-courses": {
    name: "UI/UX",
    skills: [
      "UI/UX",
      "Figma",
      "Careers in UX Design",
      "Wireframing, Prototyping, & Laws for UX",
      "Product/ UX Strategy",
      "Elements of UI Design",
      "Designer Developer Handoff",
      "Information Architecture",
      "Task Flow & User Flow",
      "Surveying Data through Card Sorting & Site Maps",
    ],
  },
  "others-courses": {
    name: "Others",
    skills: [
      "Mastering English",
      "Diabetic Management",
      "Photography",
      "Public Speaking",
      "Yoga",
    ],
  },
  "business-management-courses": {
    name: "Business & Management",
    skills: [
      "Microsoft Excel Basic",
      "Scrum Master",
      "Product Management",
      "Business Intelligence",
      "Microsoft Excel Advanced",
      "Mastering Freelancing",
      "Management Information System",
      "Microsoft Word",
      "HR Talent Acquisition and Team building",
      "Microsoft Powerpoint Advanced",
      "Microsoft Powerpoint Basic",
      "Credit Fraud Analysis",
      "Manufacturing Execution System",
      "Microsoft Word Advanced",
      "Google Sheets",
      "Sales Course",
      "Google Docs",
      "Google Slides",
      "Human Resource Business Partner",
    ],
  },
  "finance-investments-courses": {
    name: "Finance & Investments",
    skills: [
      "Stock Market Basics",
      "Tally",
      "Financial Accounting",
      "Forex Trading",
      "Fundamentals of SAP",
      "Advanced Stock Market Strategies",
      "Financial Advisory and Portfolio Management",
      "Financial Analysis",
      "Bank Accounting",
      "Forex Trading",
      "Accounting Documents",
      "Controlling",
    ],
  },
  "operating-system-and-databases-courses": {
    name: "Operating System and Databases",
    skills: [
      "SQL Basic",
      "MySQL",
      "SQL Advanced",
      "Mongo DB",
      "Linux Basic",
      "Linux Advanced",
      "Shell Scripting",
      "Redis",
      "FastAPI Backend",
    ],
  },
  "hardware-and-network-security-courses": {
    name: "Hardware and Network Security",
    skills: [
      "Cyber Security",
      "Ethical Hacking",
      "CCNA",
      "Arduino",
      "Comptia A+",
      "5G Wireless Engineer",
      "Comptia N+",
      "Kali Linux",
    ],
  },
  "design-art-tools-courses": {
    name: "Design, Art & Tools",
    skills: [
      "Canva - Graphic Designing",
      "Photoshop Basic",
      "AutoCAD",
      "Photoshop Advanced",
      "Graphic Designing - Concepts",
      "Solidworks",
      "Interior Designing With AutoCAD",
      "Digital Art Advanced",
      "Motion Graphics Basic",
      "Digital Art Basic",
      "Catia",
      "Sketching Basics",
      "SketchUp",
      "AI Design Mastery",
      "Premiere Pro",
      "Guide to Illustrator",
      "Make Up",
      "After Effects",
      "Wondershare Filmora",
      "Blender Advanced",
      "Blender Basic",
      "Krita",
      "DaVinci Resolve",
      "Lightroom",
      "Skinning, Rigging & Animation",
      "Brush Pen Calligraphy",
      "Adobe XD",
      "Substance Painter",
      "GIMP",
      "Embroidery",
      "Inkscape",
      "Revit",
      "Motion Graphics - Advanced",
      "Introduction to Maya",
    ],
  },
  "cloud-computing-courses": {
    name: "Cloud Computing",
    skills: [
      "Oracle Cloud Infrastructure Basics",
      "Amazon Web Services Analytics",
      "Amazon Web Services Database",
      "Oracle Cloud Core Infrastructure Advanced",
      "SaaS",
      "Azure",
      "Linux for DevOps Engineers",
      "Kubernetes",
      "Docker Basic",
      "Docker Advanced",
    ],
  },
  "film-making-courses": {
    name: "Film Making",
    skills: [
      "Film Editing Basics",
      "Theory and Practical Cinematography",
      "Story, Scripting and Story Boarding",
      "Sound Production and Design",
      "Elemental Creation Basic of Film Making",
      "Graphical Animation of Films with Communication Research",
      "Film Theories and its Societal Impact",
      "Film Production Design",
      "Film Financing and Distribution",
      "Sound Designing on Set",
      "Corporate Communications in Film Making",
      "Sparkling Art of Film Direction",
      "Film Advertising and Public Relations",
    ],
  },
  "web-3-courses": {
    name: "Web 3",
    skills: ["Blockchain"],
  },
  "development-tools-and-no-code-courses": {
    name: "Development Tools and No Code",
    skills: [
      "Software Testing",
      "Jira",
      "WordPress",
      "Salesforce App Builder and Administrator",
      "Postman Tool",
      "Git",
      "Oracle Application Express Application Development",
      "Selenium",
      "Android Studio",
      "Jenkins",
      "Playwright API Automation",
      "Unreal Engine",
      "WIX",
      "Apache Cordova",
      "Prometheus",
    ],
  },
  "music-courses": {
    name: "Music",
    skills: [
      "Guitar Advanced",
      "Guitar Basics",
      "Piano",
      "Violin",
      "FL Studio 20",
      "FL Studio 12",
      "FL Studio Music Production",
    ],
  },
  "job-application-guides": {
    name: "Job Application Guides",
    skills: [
      "Learn English From Scratch In Hindi",
      "Software Developer Job in Google",
      "Strategies and Techniques for Interview Success",
      "Path to Google's QA Team",
      "Path to Infosys's QA Team",
      "Software Developer Job in Oracle",
      "Path to Accenture's QA Team",
      "Software Developer Job in Deloitte",
      "Software Developer Job in Accenture",
      "Software Developer Job in Infosys",
      "Mastering UI/UX Designer Application & Interview",
      "Path to Deloitte's QA Team",
    ],
  },
};

export const allPopularSkills = [
  "Java Basic",
  "Python Basic",
  "HTML",
  "Digital Marketing",
  "C Programming",
  "C++",
  "Java Advanced",
  "UI/UX",
  "Data Analytics",
  "Stock Market Basics",
  "Python Advanced",
  "JavaScript Basic",
  "SQL Basic",
  "Social Media Marketing",
  "Data Structure and Algorithm",
  "Microsoft Excel Basic",
  "Bootstrap",
  "Mastering English",
  "SEO",
  "Power BI Basic",
  "Oracle Cloud Infrastructure Basics",
  "Cyber Security",
  "Tally",
  "Machine Learning",
  "Scrum Master",
  "React JS",
  "Canva - Graphic Designing",
  "Photoshop Basic",
  "Ethical Hacking",
  "Product Management",
  "Business Intelligence",
  "JavaScript Advanced",
  "Amazon Web Services Analytics",
  "Power BI Advanced",
  "Financial Accounting",
  "Microsoft Excel Advanced",
  "Applied Artificial Intelligence",
  "PHP",
  "CSS",
  "Forex Trading",
  "Software Testing",
  "CCNA",
  "Learn English From Scratch In Hindi",
  "Affiliate Marketing",
  "Content Writing",
  "Figma",
  "AutoCAD",
  "Arduino",
  "Diabetic Management",
  "Mastering ChatGPT",
  "SAP",
  "Advanced Stock Market",
  "Amazon Web Services Database",
  "Careers in UX Design",
  "Android App Development",
  "MySQL",
  "Oracle Cloud Core Infrastructure Advanced",
  "Content Marketing",
  "Photoshop Advanced",
  "Financial Advisory and Portfolio Management",
  "Search Engine Marketing",
  "Jira",
  "Django Basic",
  "Azure",
  "Film Editing Basics",
  "SQL Advanced",
  "R Programming",
  "Graphic Designing - Concepts",
  "C# Basic",
  "Node.JS",
  "Solidworks",
  "Blockchain",
  "Mongo DB",
  "Financial Analysis",
  "Linux Basic",
  "Google Analytics",
  "Tableau Basic",
  "Email Marketing",
  "Deep Learning",
  "Laravel",
  "Web Analytics",
  "Mastering Freelancing",
  "Interior Designing With AutoCAD",
  "Display Advertisements",
  "Wireframing, Prototyping, & Laws for UX",
  "Bank Accounting",
  "Photography",
  "Project Management",
  "Statistical Modelling",
  "Flutter",
  "WordPress",
  "Product/ UX Strategy",
  "Digital Art Advanced",
  "Comptia A+",
  "DSA in Java",
  "Lead Generation",
  "Angular JS",
  "Branding & Design Essentials",
  "Influencer Marketing",
  "Linux Advanced",
  "Salesforce App Builder and Administrator",
  "Tableau Advanced",
  "DSA With JavaScript",
  "SpringBoot",
  "Motion Graphics Basic",
  "Django Advanced",
  "SaaS",
  "Microsoft Word",
  "Digital Art Basic",
  "AI Social Media Mastery",
  "Paid Ads and Paid Media",
  "PostgreSQL",
  "Drop Shipping",
  "AI Content Mastery",
  "5G Wireless Engineer",
];

export const currentPopularSkills = [
  "HR Management",
  "Project Management",
  "Complete Data Analytics",
  "Data Analytics",
  "SQL",
  "Cybersecurity",
  "Excel",
  "Leadership Skill",
  "Business Analyst",
  "Operations Management",
  "Python for DA",
  "Six Sigma",
  "Artificial Intelligence",
  "Prompt Engineering",
  "Power BI",
  "People Management",
  "AI Agents Developer",
  "Automation Testing",
  "Python for Data Science",
  "AI Automation",
];

export const currentPopularSkillsCount = [
  { subject_name: "HR Management", total_count: 2432 },
  { subject_name: "Project Management", total_count: 1794 },
  { subject_name: "Complete Data Analytics", total_count: 1424 },
  { subject_name: "Data Analytics", total_count: 901 },
  { subject_name: "SQL", total_count: 815 },
  { subject_name: "Cybersecurity", total_count: 808 },
  { subject_name: "Excel", total_count: 727 },
  { subject_name: "Leadership Skill", total_count: 721 },
  { subject_name: "Business Analyst", total_count: 672 },
  { subject_name: "Operations Management", total_count: 664 },
  { subject_name: "Python for DA", total_count: 656 },
  { subject_name: "Six Sigma", total_count: 589 },
  { subject_name: "Artificial Intelligence", total_count: 563 },
  { subject_name: "Prompt Engineering", total_count: 344 },
  { subject_name: "Power BI", total_count: 325 },
  { subject_name: "People Management", total_count: 288 },
  { subject_name: "AI Agents Developer", total_count: 284 },
  { subject_name: "Automation Testing", total_count: 274 },
  { subject_name: "Python for Data Science", total_count: 274 },
  { subject_name: "AI Automation", total_count: 260 },
];

export default constants;
